import { Provider } from 'react-redux';
import { configureStore, isRejectedWithValue } from '@reduxjs/toolkit';
import { authApi } from '@/services/auth-api';
import { generalApi } from '@/services/general-api';
import { parentApi } from '@/services/parent-api';
import { childApi } from '@/services/child-api';
import { siblingGroupApi } from '@/services/sibling-group-api';
import { usersApi } from '@/services/users-api';
import authReducer, { logout } from './auth';

const rtkQueryErrorLogger = (api) => (next) => (action) => {
  if (isRejectedWithValue(action) && action.payload.status === 401) {
    api.dispatch(logout());
  }
  return next(action);
};

const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [generalApi.reducerPath]: generalApi.reducer,
    [parentApi.reducerPath]: parentApi.reducer,
    [childApi.reducerPath]: childApi.reducer,
    [siblingGroupApi.reducerPath]: siblingGroupApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      rtkQueryErrorLogger,
      authApi.middleware,
      generalApi.middleware,
      parentApi.middleware,
      childApi.middleware,
      siblingGroupApi.middleware,
      usersApi.middleware,
    ),
  devTools: process.env.NODE_ENV !== 'production',
});

export const StoreProvider = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};
